export default __webpack_public_path__ + "static/media/penetratingshot1.e2f43b8b.png";